var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 1.46004C8.96824 1.15248 9.98028 0.997298 10.998 1.00004C15.18 1.00004 18.026 3.50004 19.723 5.70404C20.573 6.81004 20.998 7.36104 20.998 9.00004C20.998 10.64 20.573 11.191 19.723 12.296C18.026 14.5 15.18 17 10.998 17C6.81605 17 3.97005 14.5 2.27305 12.296C1.42305 11.192 0.998047 10.639 0.998047 9.00004C0.998047 7.36004 1.42305 6.80904 2.27305 5.70404C2.79141 5.02674 3.36866 4.39662 3.99805 3.82104",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 9C13.998 9.79565 13.682 10.5587 13.1194 11.1213C12.5568 11.6839 11.7937 12 10.998 12C10.2024 12 9.43934 11.6839 8.87673 11.1213C8.31412 10.5587 7.99805 9.79565 7.99805 9C7.99805 8.20435 8.31412 7.44129 8.87673 6.87868C9.43934 6.31607 10.2024 6 10.998 6C11.7937 6 12.5568 6.31607 13.1194 6.87868C13.682 7.44129 13.998 8.20435 13.998 9Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d5e3f0e063c97f754c30039184e15083.svg";
export { ForwardRef as ReactComponent };